import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('xdx_token'));
  const [loading, setLoading] = useState(true);

  const setAuth = useCallback((tkn, usr) => {
    setToken(tkn);
    setUser(usr);
    if (tkn) {
      localStorage.setItem('xdx_token', tkn);
      axios.defaults.headers.common['Authorization'] = `Bearer ${tkn}`;
    } else {
      localStorage.removeItem('xdx_token');
      delete axios.defaults.headers.common['Authorization'];
    }
  }, []);

  useEffect(() => {
    const loadUser = async () => {
      if (token) {
        try {
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          const res = await axios.get(`${API}/auth/me`);
          setUser(res.data);
        } catch {
          setAuth(null, null);
        }
      }
      setLoading(false);
    };
    loadUser();
  }, [token, setAuth]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    if (res.data.requires_2fa) {
      return { requires_2fa: true };
    }
    setAuth(res.data.token, res.data.user);
    return res.data.user;
  };

  const register = async (name, email, password) => {
    const res = await axios.post(`${API}/auth/register`, { name, email, password });
    setAuth(res.data.token, res.data.user);
    return res.data.user;
  };

  const auth0Login = () => {
    const domain = process.env.REACT_APP_AUTH0_DOMAIN;
    const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
    const redirectUri = `${window.location.origin}/auth/callback`;
    window.location.href = `https://${domain}/authorize?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=openid profile email`;
  };

  const handleAuth0Callback = async (code) => {
    const redirectUri = `${window.location.origin}/auth/callback`;
    const res = await axios.post(`${API}/auth/auth0-callback`, { code, redirect_uri: redirectUri });
    setAuth(res.data.token, res.data.user);
    return res.data.user;
  };

  const logout = () => {
    setAuth(null, null);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, auth0Login, handleAuth0Callback, setAuth, isAdmin: user?.role === 'admin' }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
